import zhCN from './json/common.zh_CN.json';
import zhTW from './json/common.zh_TW.json';
import en from './json/common.en.json';
import ja from './json/common.ja.json';
import ko from './json/common.ko.json';
import ru from './json/common.ru.json';
export default {
  zh_CN: zhCN,
  zh_TW: zhTW,
  en,
  ja,
  ko,
  ru
};
